import React, {
    useEffect,
    useRef,
    useState,
} from "react";

import Swal from "sweetalert2";

import api from "../../services/api";

import {
    useNavigate,
} from "react-router-dom";

import {
    PiEyeLight,
    PiEyeClosedLight,
} from "react-icons/pi";

import {
    FiUser,
    FiMail,
    FiPhone,
    FiShield,
    FiCheck,
    FiAlertCircle,
    FiLock,
    FiArrowRight,
    FiArrowLeft,
} from "react-icons/fi";

import InputMask from "react-input-mask";

import {
    Tooltip,
} from "antd";

import "./atualizacaoCadastro.scss";
import logo from "../../assets/logo.png";


export default function AtualizacaoCadastro() {

    /* =========================================================
       ESTADOS
       ========================================================= */

    const [loading, setLoading] =
        useState(false);

    const navigate =
        useNavigate();

    const [mostrarSenha, setMostrarSenha] =
        useState(false);

    const [
        telefoneDisponivel,
        setTelefoneDisponivel,
    ] = useState(null);

    const [
        verificandoTelefone,
        setVerificandoTelefone,
    ] = useState(false);

    const [
        erroSenha,
        setErroSenha,
    ] = useState("");

    const [
        emailObrigatorio,
        setEmailObrigatorio,
    ] = useState(false);

    const telefoneTimeout =
        useRef(null);


    const loginTimeout =
        useRef(null);

    const [editandoNome, setEditandoNome] = useState(false);
    const [editandoLogin, setEditandoLogin] =
        useState(false);

    const [loginDisponivel, setLoginDisponivel] =
        useState(null);

    /* =========================================================
       DADOS ORIGINAIS DO CADASTRO
       Usados para identificar o que realmente foi alterado.
       ========================================================= */

    const [dadosOriginais, setDadosOriginais] = useState({

        nome: "",

        user: "",

        email: "",

        telefone: "",

        email_verificado: false,

        telefone_verificado: false,

    });

    /* =========================================================
       DADOS DO USUÁRIO
       ========================================================= */

    const [
        values,
        setValues,
    ] = useState({

        nome: "",

        user: "",

        email: "",

        telefone: "",

        email_verificado: false,

        telefone_verificado: false,

        senhaAtual: "",

        novaSenha: "",

        confirmarSenha: "",

    });


    const verificarLoginDigitado = async (login) => {

        const valor = login?.trim();

        // Limpa quando estiver vazio
        if (!valor) {

            setLoginDisponivel(null);

            return;

        }

        // Não consulta enquanto tiver menos de 3 caracteres
        if (valor.length < 3) {

            setLoginDisponivel(null);

            return;

        }

        try {

            const response =
                await api.get(
                    "/verificar-login",
                    {
                        ...getHeaders(),

                        params: {
                            user: valor
                        }
                    }
                );


            console.log(
                "VERIFICAÇÃO LOGIN:",
                response.data
            );


            setLoginDisponivel(
                response.data.disponivel
            );


            // ==========================================
            // LOGIN JÁ EXISTE
            // ==========================================

            if (!response.data.disponivel) {

                await Swal.fire({

                    title:
                        "Login já utilizado",

                    html: `
                    <div class="swal-login-existente-text">

                        Este nome de login já está
                        cadastrado.

                        <br />

                        Escolha outro nome de login.

                    </div>
                `,

                    width: 430,

                    showConfirmButton: true,

                    confirmButtonText: "OK",

                    buttonsStyling: false,

                    scrollbarPadding: false,

                    customClass: {

                        popup:
                            "swal-login-existente-popup",

                        title:
                            "swal-login-existente-title",

                        htmlContainer:
                            "swal-login-existente-html",

                        actions:
                            "swal-login-existente-actions",

                        confirmButton:
                            "swal-login-existente-confirm",

                    },

                });

            }

        } catch (error) {

            console.error(
                "ERRO AO VERIFICAR LOGIN:",
                error.response?.data ||
                error
            );

        }

    };


    /* =========================================================
       HEADERS / TOKEN
       ========================================================= */

    const getHeaders = () => {

        return {

            headers: {

                inova:
                    `Bearer ${localStorage.getItem("inova")}`,

            },

        };

    };


    /* =========================================================
       ATUALIZAR NOME
       ========================================================= */

    const atualizarNome = async () => {

        const nome =
            values.nome?.trim();


        if (!nome) {

            throw new Error(
                "O nome não pode ficar vazio."
            );

        }


        try {

            const response =
                await api.put(

                    "/atualizar-nome",

                    {
                        nome: values.nome,
                    },

                    getHeaders()

                );


            console.log(
                "NOME ATUALIZADO:",
                response.data
            );


            return response.data;

        } catch (error) {

            console.error(
                "ERRO AO ATUALIZAR NOME:",
                error.response?.data ||
                error
            );


            throw error;

        }

    };

    const atualizarLogin = async () => {

        const login = values.user?.trim();

        if (!login) {
            throw new Error(
                "O nome de login não pode ficar vazio."
            );
        }

        console.log("=== ATUALIZANDO LOGIN ===");
        console.log("LOGIN:", login);
        console.log("URL:", "/atualizar-login");

        try {

            const response = await api.put(
                "/atualizar-nome-login",

                {
                    user: login,
                },
                getHeaders()
            );

            console.log(
                "LOGIN ATUALIZADO:",
                response.data
            );

            return response.data;

        } catch (error) {

            console.error(
                "ERRO AO ATUALIZAR LOGIN:",
                error
            );

            console.error(
                "STATUS:",
                error.response?.status
            );

            console.error(
                "DATA:",
                error.response?.data
            );

            console.error(
                "URL:",
                error.config?.url
            );

            throw error;
        }
    };

    const handleAlterarLogin = async () => {

        const confirmacao =
            await Swal.fire({

                background: "#08131d",

                width: "400px",

                padding: "0",

                html: `

                <div class="swal-alterar-campo">

                    <div class="swal-alterar-campo-top">

                        <div class="swal-alterar-campo-icon">
                            <FiUser />
                        </div>

                        <div class="swal-alterar-campo-status">

                            <span></span>

                            CONFIGURAÇÃO DA CONTA

                        </div>

                    </div>


                    <div class="swal-alterar-campo-title">

                        Alterar login

                    </div>


                    <div class="swal-alterar-campo-text">

                        Deseja habilitar a edição do
                        nome de login da sua conta?

                    </div>


                    <div class="swal-alterar-campo-info">

                        <span class="swal-info-dot"></span>

                        O campo será desbloqueado
                        para edição.

                    </div>

                </div>

            `,

                showCancelButton: true,

                confirmButtonText: "Continuar",

                cancelButtonText: "Cancelar",

                reverseButtons: true,

                buttonsStyling: false,

                allowOutsideClick: false,

                allowEscapeKey: true,

                scrollbarPadding: false,

                customClass: {

                    popup:
                        "swal-alterar-campo-popup",

                    htmlContainer:
                        "swal-alterar-campo-content",

                    actions:
                        "swal-alterar-campo-actions",

                    confirmButton:
                        "swal-alterar-campo-confirm",

                    cancelButton:
                        "swal-alterar-campo-cancel",

                },

            });


        if (!confirmacao.isConfirmed) {

            return;

        }


        setEditandoLogin(true);

    };


    const verificarLogin = async () => {

        const login =
            values.user?.trim();


        if (!login) {

            return false;

        }


        if (login.length < 3) {

            return false;

        }


        try {

            const response =
                await api.get(

                    "/verificar-login",

                    {
                        ...getHeaders(),

                        params: {
                            user: login
                        }

                    }

                );


            console.log(
                "VERIFICAÇÃO DO LOGIN:",
                response.data
            );


            if (!response.data.disponivel) {

                await Swal.fire({

                    title:
                        "Login já utilizado",

                    html: `
                    <div class="swal-login-existente-text">

                        Este nome de login já está
                        cadastrado.

                        <br />

                        Escolha outro nome de login.

                    </div>
                `,

                    width: 430,

                    showConfirmButton: true,

                    confirmButtonText:
                        "OK",

                    buttonsStyling: false,

                    scrollbarPadding: false,

                    customClass: {

                        popup:
                            "swal-login-existente-popup",

                        title:
                            "swal-login-existente-title",

                        htmlContainer:
                            "swal-login-existente-html",

                        actions:
                            "swal-login-existente-actions",

                        confirmButton:
                            "swal-login-existente-confirm",

                    },

                });


                return false;

            }


            console.log(
                "LOGIN DISPONÍVEL:",
                login
            );


            return true;


        } catch (error) {

            console.error(
                "ERRO AO VERIFICAR LOGIN:",
                error.response?.data ||
                error
            );


            await Swal.fire({

                title:
                    "Não foi possível verificar",

                html: `
                <div class="swal-login-existente-text">
                    Não foi possível verificar
                    a disponibilidade do login.
                </div>
            `,

                width: 430,

                confirmButtonText:
                    "OK",

                buttonsStyling: false,

                scrollbarPadding: false,

                customClass: {

                    popup:
                        "swal-login-existente-popup",

                    title:
                        "swal-login-existente-title",

                    htmlContainer:
                        "swal-login-existente-html",

                    actions:
                        "swal-login-existente-actions",

                    confirmButton:
                        "swal-login-existente-confirm",

                },

            });


            return false;

        }

    };



    /* =========================================================
       CARREGAR USUÁRIO
       ========================================================= */

    const carregarUsuario =
        async () => {

            try {

                const response =
                    await api.get(

                        "/dadosConta",

                        getHeaders()

                    );

                console.log(
                    "DADOS RETORNADOS PELO BACKEND:",
                    response.data
                );

                console.log(
                    "USER RETORNADO:",
                    response.data.user
                );


                const emailUsuario =
                    response.data.email || "";


                const emailValido =
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


                const emailVerificado =
                    emailValido.test(
                        emailUsuario
                    );


                const dadosCarregados = {

                    nome:
                        response.data.nome ||
                        "",

                    user:
                        response.data.user ||
                        "",

                    email:
                        response.data.email ||
                        "",

                    telefone:
                        response.data.telefone ||
                        "",

                    email_verificado:
                        emailVerificado,

                    telefone_verificado:
                        response.data.telefone_verificado ||
                        false,

                };


                setValues({

                    ...dadosCarregados,

                    senhaAtual:
                        "",

                    novaSenha:
                        "",

                    confirmarSenha:
                        "",

                });


                setDadosOriginais(
                    dadosCarregados
                );


                setEmailObrigatorio(
                    !emailVerificado
                );

            } catch (error) {

                console.log(
                    "ERRO AO CARREGAR USUÁRIO:",
                    error.response?.data ||
                    error
                );


                await Swal.fire({

                    icon: "error",

                    title:
                        "Erro ao carregar",

                    text:
                        "Não foi possível carregar os dados da sua conta.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#0f73b2",

                    confirmButtonText:
                        "Voltar",

                });

            }

        };


    /* =========================================================
       USE EFFECT
       ========================================================= */

    useEffect(() => {

        carregarUsuario();


        return () => {

            clearTimeout(
                telefoneTimeout.current
            );

        };

    }, []);


    /* =========================================================
       ALTERAÇÃO DOS CAMPOS
       ========================================================= */

    const handleChange = (e) => {

        const {
            name,
            value,
        } = e.target;


        setValues((prev) => ({

            ...prev,

            [name]:
                value,

        }));


        // ==========================================
        // VERIFICAR LOGIN ENQUANTO DIGITA
        // ==========================================

        if (
            name === "user" &&
            editandoLogin
        ) {

            clearTimeout(
                loginTimeout.current
            );


            loginTimeout.current =
                setTimeout(() => {

                    verificarLoginDigitado(
                        value
                    );

                }, 500);

        }


        /* =====================================================
           VALIDAÇÃO DE SENHA
           ===================================================== */

        if (

            name === "novaSenha" ||

            name === "confirmarSenha" ||

            name === "senhaAtual"

        ) {

            const novaSenha =

                name === "novaSenha"

                    ? value

                    : values.novaSenha;


            const confirmarSenha =

                name === "confirmarSenha"

                    ? value

                    : values.confirmarSenha;


            if (

                confirmarSenha &&

                novaSenha !== confirmarSenha

            ) {

                setErroSenha(
                    "As senhas não coincidem."
                );

            } else {

                setErroSenha("");

            }

        }


        /* =====================================================
           TELEFONE
           ===================================================== */

        if (
            name === "telefone"
        ) {

            clearTimeout(
                telefoneTimeout.current
            );


            setTelefoneDisponivel(
                null
            );


            const telefoneLimpo =
                value.replace(
                    /\D/g,
                    ""
                );


            if (
                telefoneLimpo.length !== 11
            ) {

                setVerificandoTelefone(
                    false
                );

                return;

            }


            setVerificandoTelefone(
                true
            );


            telefoneTimeout.current =
                setTimeout(() => {

                    verificarDisponibilidadeTelefone(
                        telefoneLimpo
                    );

                }, 600);

        }

    };


    /* =========================================================
       FORMATAR TELEFONE
       ========================================================= */

    const formatarTelefone =
        (telefone = "") => {

            const numeros =
                telefone.replace(
                    /\D/g,
                    ""
                );


            const limpo =
                numeros
                    .replace(/^55/, "")
                    .slice(0, 11);


            return limpo.replace(

                /(\d{2})(\d{5})(\d{4})/,

                "($1) $2-$3"

            );

        };


    /* =========================================================
       VERIFICAR TELEFONE
       ========================================================= */

    const verificarDisponibilidadeTelefone =
        async (telefone) => {

            setTelefoneDisponivel(
                null
            );


            if (
                telefone.length !== 11
            ) {

                setVerificandoTelefone(
                    false
                );

                return;

            }


            try {

                const idUsuario =
                    localStorage.getItem(
                        "id"
                    );


                await api.post(

                    "/usuario/verificar-telefone",

                    {
                        telefone,
                        id:
                            idUsuario,
                    },

                    getHeaders()

                );


                setTelefoneDisponivel(
                    true
                );

            } catch (error) {

                console.log(
                    "VERIFICAR TELEFONE:",
                    error.response?.data
                );


                if (

                    error.response?.status === 400 ||

                    error.response?.status === 409

                ) {

                    setTelefoneDisponivel(
                        false
                    );

                } else {

                    setTelefoneDisponivel(
                        null
                    );

                }

            } finally {

                setVerificandoTelefone(
                    false
                );

            }

        };


    /* =========================================================
       ENVIAR CÓDIGO SMS
       ========================================================= */

    const handleEnviarCodigo =
        async () => {

            try {

                await api.post(

                    "/enviarCodigoTelefone",

                    {
                        telefone:
                            values.telefone,
                    },

                    getHeaders()

                );


                const codigoModal =
                    await Swal.fire({

                        html: `

                            <div class="telefone-verificacao-modal">

                                <div class="telefone-verificacao-icon">
                                    ☎
                                </div>

                                <h2 class="telefone-verificacao-title">
                                    Verificar telefone
                                </h2>

                                <p class="telefone-verificacao-description">
                                    Enviamos um código de segurança para:
                                </p>

                                <div class="telefone-verificacao-number">
                                    ${formatarTelefone(
                            values.telefone
                        )}
                                </div>

                                <div class="telefone-codigo-label">
                                    Código de verificação
                                </div>

                                <div class="telefone-codigo-inputs">

                                    <input
                                        id="codigo-telefone-1"
                                        maxLength="1"
                                        inputMode="numeric"
                                    />

                                    <input
                                        id="codigo-telefone-2"
                                        maxLength="1"
                                        inputMode="numeric"
                                    />

                                    <input
                                        id="codigo-telefone-3"
                                        maxLength="1"
                                        inputMode="numeric"
                                    />

                                    <span class="telefone-codigo-separador"></span>

                                    <input
                                        id="codigo-telefone-4"
                                        maxLength="1"
                                        inputMode="numeric"
                                    />

                                    <input
                                        id="codigo-telefone-5"
                                        maxLength="1"
                                        inputMode="numeric"
                                    />

                                    <input
                                        id="codigo-telefone-6"
                                        maxLength="1"
                                        inputMode="numeric"
                                    />

                                </div>

                                <div class="telefone-verificacao-help">
                                    Digite o código de 6 dígitos recebido por SMS.
                                </div>

                            </div>

                        `,

                        background:
                            "#0b1623",

                        color:
                            "#ffffff",

                        width:
                            "430px",

                        padding:
                            "28px",

                        showCancelButton:
                            true,

                        confirmButtonText:
                            "Confirmar telefone",

                        cancelButtonText:
                            "Cancelar",

                        reverseButtons:
                            true,

                        allowOutsideClick:
                            false,

                        allowEscapeKey:
                            false,

                        focusConfirm:
                            false,

                        buttonsStyling:
                            false,

                        customClass: {

                            popup:
                                "telefone-verificacao-popup",

                            actions:
                                "telefone-verificacao-actions",

                            confirmButton:
                                "telefone-verificacao-confirmar",

                            cancelButton:
                                "telefone-verificacao-cancelar",

                        },


                        didOpen: () => {

                            const inputs = [

                                document.getElementById(
                                    "codigo-telefone-1"
                                ),

                                document.getElementById(
                                    "codigo-telefone-2"
                                ),

                                document.getElementById(
                                    "codigo-telefone-3"
                                ),

                                document.getElementById(
                                    "codigo-telefone-4"
                                ),

                                document.getElementById(
                                    "codigo-telefone-5"
                                ),

                                document.getElementById(
                                    "codigo-telefone-6"
                                ),

                            ];


                            inputs[0]?.focus();


                            inputs.forEach(
                                (input, index) => {

                                    if (!input)
                                        return;


                                    input.addEventListener(
                                        "input",
                                        (event) => {

                                            event.target.value =
                                                event.target.value
                                                    .replace(
                                                        /\D/g,
                                                        ""
                                                    )
                                                    .slice(
                                                        0,
                                                        1
                                                    );


                                            if (

                                                event.target.value &&

                                                index <
                                                inputs.length - 1

                                            ) {

                                                inputs[
                                                    index + 1
                                                ]?.focus();

                                            }

                                        }
                                    );


                                    input.addEventListener(
                                        "keydown",
                                        (event) => {

                                            if (

                                                event.key ===
                                                "Backspace" &&

                                                !input.value &&

                                                index > 0

                                            ) {

                                                inputs[
                                                    index - 1
                                                ]?.focus();

                                            }

                                        }
                                    );


                                    input.addEventListener(
                                        "paste",
                                        (event) => {

                                            event.preventDefault();


                                            const codigo =
                                                event
                                                    .clipboardData
                                                    .getData(
                                                        "text"
                                                    )
                                                    .replace(
                                                        /\D/g,
                                                        ""
                                                    )
                                                    .slice(
                                                        0,
                                                        6
                                                    );


                                            codigo
                                                .split("")
                                                .forEach(
                                                    (
                                                        numero,
                                                        i
                                                    ) => {

                                                        if (
                                                            inputs[i]
                                                        ) {

                                                            inputs[
                                                                i
                                                            ].value =
                                                                numero;

                                                        }

                                                    }
                                                );


                                            inputs[
                                                Math.min(
                                                    codigo.length,
                                                    5
                                                )
                                            ]?.focus();

                                        }
                                    );

                                }
                            );

                        },


                        preConfirm:
                            async () => {

                                const codigo = [

                                    document.getElementById(
                                        "codigo-telefone-1"
                                    )?.value,

                                    document.getElementById(
                                        "codigo-telefone-2"
                                    )?.value,

                                    document.getElementById(
                                        "codigo-telefone-3"
                                    )?.value,

                                    document.getElementById(
                                        "codigo-telefone-4"
                                    )?.value,

                                    document.getElementById(
                                        "codigo-telefone-5"
                                    )?.value,

                                    document.getElementById(
                                        "codigo-telefone-6"
                                    )?.value,

                                ].join("");


                                if (
                                    codigo.length !== 6
                                ) {

                                    Swal.showValidationMessage(
                                        "Digite os 6 dígitos do código."
                                    );

                                    return false;

                                }


                                try {

                                    await api.post(

                                        "/validarCodigoTelefone",

                                        {
                                            telefone:
                                                values.telefone,

                                            codigo,
                                        },

                                        getHeaders()

                                    );


                                    return true;

                                } catch (error) {

                                    Swal.showValidationMessage(

                                        error.response
                                            ?.data
                                            ?.mensagem ||

                                        "Código inválido ou expirado."

                                    );


                                    return false;

                                }

                            },

                    });


                if (
                    !codigoModal.isConfirmed
                ) {

                    return;

                }


                setValues((prev) => ({

                    ...prev,

                    telefone_verificado:
                        true,

                }));


                setTelefoneDisponivel(
                    true
                );


                await Swal.fire({

                    icon:
                        "success",

                    title:
                        "Telefone confirmado",

                    text:
                        "Seu telefone foi verificado com sucesso.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#0f73b2",

                    confirmButtonText:
                        "Continuar",

                });

            } catch (error) {

                console.log(
                    "ERRO SMS:",
                    error.response?.data ||
                    error
                );


                Swal.fire({

                    icon:
                        "error",

                    title:
                        "Erro",

                    text:
                        error.response?.data
                            ?.mensagem ||

                        "Não foi possível enviar o código.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#ef4444",

                });

            }

        };


    /* =========================================================
       ALTERAR E-MAIL
       ========================================================= */

    const handleAlterarEmail =
        async () => {

            const result =
                await Swal.fire({

                    title:
                        "Cadastrar novo e-mail",

                    html: `

                                    <div class="email-form-content">

                                        <div class="email-form-description">
                                            Informe o novo endereço de e-mail
                                            que será vinculado à sua conta.
                                        </div>

                                        <div class="email-input-wrapper">

                                            <label>
                                                Novo e-mail
                                            </label>

                                            <div class="email-input-container">

                                                <input
                                                    id="novo-email"
                                                    type="email"
                                                    class="email-custom-input"
                                                    placeholder="seuemail@exemplo.com"
                                                    autocomplete="email"
                                                />

                                                <span
                                                    id="email-status"
                                                    class="email-status"
                                                ></span>

                                            </div>

                                            <div
                                                id="email-validation-message"
                                                class="email-validation-message"
                                            ></div>

                                        </div>

                                        <div class="email-form-info">

                                            <span class="email-info-dot"></span>

                                            <span>
                                                Um código será enviado para
                                                confirmar o novo endereço.
                                            </span>

                                        </div>

                                    </div>

                                `,

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    width:
                        "520px",

                    allowOutsideClick:
                        false,

                    allowEscapeKey:
                        false,

                    showCancelButton:
                        true,

                    confirmButtonText:
                        "Continuar",

                    cancelButtonText:
                        "Cancelar",

                    reverseButtons:
                        true,

                    buttonsStyling:
                        false,

                    customClass: {

                        popup:
                            "popup-email-obrigatorio",

                        title:
                            "titulo-email-obrigatorio",

                        htmlContainer:
                            "conteudo-email-obrigatorio",

                        confirmButton:
                            "botao-email-obrigatorio",

                        cancelButton:
                            "botao-cancelar-email",

                    },


                    didOpen: () => {

                        const input =
                            document.getElementById(
                                "novo-email"
                            );

                        const status =
                            document.getElementById(
                                "email-status"
                            );

                        const message =
                            document.getElementById(
                                "email-validation-message"
                            );


                        input?.focus();


                        let timeout =
                            null;


                        input?.addEventListener(
                            "input",
                            () => {

                                clearTimeout(
                                    timeout
                                );


                                const email =
                                    input.value
                                        .trim()
                                        .toLowerCase();


                                status.innerHTML =
                                    "";

                                message.innerHTML =
                                    "";


                                input.classList.remove(
                                    "email-valid",
                                    "email-invalid",
                                    "email-checking"
                                );


                                if (!email)
                                    return;


                                const emailValido =
                                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


                                if (
                                    !emailValido.test(
                                        email
                                    )
                                ) {

                                    input.classList.add(
                                        "email-invalid"
                                    );

                                    status.innerHTML =
                                        "✕";

                                    message.innerHTML =
                                        "Digite um e-mail válido.";

                                    return;

                                }


                                timeout =
                                    setTimeout(
                                        async () => {

                                            input.classList.add(
                                                "email-checking"
                                            );


                                            status.innerHTML =
                                                `<span class="email-spinner"></span>`;


                                            message.innerHTML =
                                                "Verificando disponibilidade...";


                                            try {

                                                const idUsuario =
                                                    localStorage.getItem(
                                                        "id"
                                                    );


                                                await api.post(

                                                    "/usuarios/verificar",

                                                    {
                                                        email,

                                                        id:
                                                            idUsuario,
                                                    },

                                                    getHeaders()

                                                );


                                                input.classList.remove(
                                                    "email-checking"
                                                );


                                                input.classList.add(
                                                    "email-valid"
                                                );


                                                status.innerHTML =
                                                    "✓";


                                                message.innerHTML =
                                                    "E-mail disponível.";

                                            } catch (error) {

                                                input.classList.remove(
                                                    "email-checking"
                                                );


                                                input.classList.add(
                                                    "email-invalid"
                                                );


                                                status.innerHTML =
                                                    "✕";


                                                message.innerHTML =
                                                    error.response
                                                        ?.data
                                                        ?.mensagem ||

                                                    "E-mail já está em uso.";

                                            }

                                        },
                                        600
                                    );

                            }
                        );

                    },


                    preConfirm:
                        async () => {

                            const input =
                                document.getElementById(
                                    "novo-email"
                                );


                            const novoEmail =
                                input?.value
                                    ?.trim()
                                    .toLowerCase();


                            if (!novoEmail) {

                                Swal.showValidationMessage(
                                    "Informe um e-mail."
                                );

                                return false;

                            }


                            const emailValido =
                                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


                            if (
                                !emailValido.test(
                                    novoEmail
                                )
                            ) {

                                Swal.showValidationMessage(
                                    "Informe um e-mail válido."
                                );

                                return false;

                            }


                            try {

                                const idUsuario =
                                    localStorage.getItem(
                                        "id"
                                    );


                                await api.post(

                                    "/usuarios/verificar",

                                    {
                                        email:
                                            novoEmail,

                                        id:
                                            idUsuario,
                                    },

                                    getHeaders()

                                );


                                return {
                                    novoEmail,
                                };

                            } catch (error) {

                                Swal.showValidationMessage(

                                    error.response
                                        ?.data
                                        ?.mensagem ||

                                    "E-mail já está em uso."

                                );


                                return false;

                            }

                        },

                });


            if (
                !result.isConfirmed
            ) {

                return;

            }


            const {
                novoEmail,
            } = result.value;


            /* =====================================================
               CONFIRMAR E-MAIL
               ===================================================== */

            const confirmar =
                await Swal.fire({

                    title:
                        "Confirme seu e-mail",

                    html: `

                        <div class="email-confirm-content">

                            <div class="email-confirm-description">
                                Confirme se o endereço abaixo está correto.
                            </div>

                            <div class="email-confirm-card">

                                <div class="email-confirm-label">
                                    Novo endereço
                                </div>

                                <div
                                    id="email-confirm-value"
                                    class="email-confirm-value"
                                ></div>

                            </div>

                            <div class="email-confirm-info">

                                <span class="email-info-dot"></span>

                                <span>
                                    Enviaremos um código de confirmação
                                    para este endereço.
                                </span>

                            </div>

                        </div>

                    `,

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    width:
                        "520px",

                    allowOutsideClick:
                        false,

                    allowEscapeKey:
                        false,

                    showCancelButton:
                        true,

                    confirmButtonText:
                        "Enviar código",

                    cancelButtonText:
                        "Voltar",

                    reverseButtons:
                        true,

                    buttonsStyling:
                        false,

                    customClass: {

                        popup:
                            "popup-email-obrigatorio",

                        title:
                            "titulo-email-obrigatorio",

                        htmlContainer:
                            "conteudo-email-obrigatorio",

                        confirmButton:
                            "botao-email-obrigatorio",

                        cancelButton:
                            "botao-cancelar-email",

                    },


                    didOpen: () => {

                        const element =
                            document.getElementById(
                                "email-confirm-value"
                            );


                        if (element) {

                            element.textContent =
                                novoEmail;

                        }

                    },

                });


            if (
                !confirmar.isConfirmed
            ) {

                return handleAlterarEmail();

            }


            /* =====================================================
               ENVIAR CÓDIGO
               ===================================================== */

            Swal.fire({

                title:
                    "Enviando código...",

                html: `

                    <div class="email-loading-content">

                        <div class="email-loading-spinner"></div>

                        <div class="email-loading-text">
                            Enviando código de confirmação.
                        </div>

                        <div class="email-loading-email">
                            ${novoEmail}
                        </div>

                    </div>

                `,

                background:
                    "#0b1623",

                color:
                    "#ffffff",

                width:
                    "420px",

                showConfirmButton:
                    false,

                allowOutsideClick:
                    false,

                allowEscapeKey:
                    false,

            });


            try {

                await api.put(

                    "/usuario/alterar-email",

                    {
                        novoEmail,
                    },

                    getHeaders()

                );


                /* =================================================
                   CÓDIGO DO E-MAIL
                   ================================================= */

                const codigoModal =
                    await Swal.fire({

                        title:
                            "Confirme seu e-mail",

                        html: `

                            <div class="codigo-email-content">

                                <div class="codigo-email-description">

                                    Enviamos um código de 6 dígitos para:

                                    <div
                                        id="codigo-email-destino"
                                        class="codigo-email-destino"
                                    ></div>

                                </div>

                                <div class="codigo-input-wrapper">

                                    <input
                                        id="codigo-email"
                                        type="text"
                                        inputMode="numeric"
                                        maxLength="6"
                                        placeholder="000000"
                                        class="codigo-email-input"
                                    />

                                </div>

                                <div class="codigo-email-help">
                                    Digite o código recebido por e-mail.
                                </div>

                            </div>

                        `,

                        background:
                            "#0b1623",

                        color:
                            "#ffffff",

                        width:
                            "500px",

                        allowOutsideClick:
                            false,

                        allowEscapeKey:
                            false,

                        showCancelButton:
                            true,

                        confirmButtonText:
                            "Confirmar código",

                        cancelButtonText:
                            "Cancelar",

                        reverseButtons:
                            true,

                        buttonsStyling:
                            false,

                        customClass: {

                            popup:
                                "popup-email-obrigatorio",

                            title:
                                "titulo-email-obrigatorio",

                            htmlContainer:
                                "conteudo-email-obrigatorio",

                            confirmButton:
                                "botao-email-obrigatorio",

                            cancelButton:
                                "botao-cancelar-email",

                        },


                        didOpen: () => {

                            const destino =
                                document.getElementById(
                                    "codigo-email-destino"
                                );


                            if (destino) {

                                destino.textContent =
                                    novoEmail;

                            }


                            const input =
                                document.getElementById(
                                    "codigo-email"
                                );


                            input?.focus();


                            input?.addEventListener(
                                "input",
                                (event) => {

                                    event.target.value =
                                        event.target.value
                                            .replace(
                                                /\D/g,
                                                ""
                                            )
                                            .slice(
                                                0,
                                                6
                                            );

                                }
                            );

                        },


                        preConfirm:
                            async () => {

                                const input =
                                    document.getElementById(
                                        "codigo-email"
                                    );


                                const codigo =
                                    input?.value?.trim();


                                if (!codigo) {

                                    Swal.showValidationMessage(
                                        "Digite o código."
                                    );

                                    return false;

                                }


                                if (
                                    codigo.length !== 6
                                ) {

                                    Swal.showValidationMessage(
                                        "O código deve possuir 6 dígitos."
                                    );

                                    return false;

                                }


                                try {

                                    await api.put(

                                        "/usuario/confirmar-alteracao-email",

                                        {
                                            codigo,
                                        },

                                        getHeaders()

                                    );


                                    return true;

                                } catch (error) {

                                    Swal.showValidationMessage(

                                        error.response
                                            ?.data
                                            ?.mensagem ||

                                        "Código inválido ou expirado."

                                    );


                                    return false;

                                }

                            },

                    });


                if (
                    !codigoModal.isConfirmed
                ) {

                    return;

                }


                setValues((prev) => ({

                    ...prev,

                    email:
                        novoEmail,

                    email_verificado:
                        true,

                }));


                setDadosOriginais((prev) => ({

                    ...prev,

                    email:
                        novoEmail,

                    email_verificado:
                        true,

                }));


                setEmailObrigatorio(
                    false
                );


                await Swal.fire({

                    icon:
                        "success",

                    title:
                        "E-mail atualizado",

                    text:
                        "Seu novo e-mail foi confirmado com sucesso.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#0f73b2",

                    confirmButtonText:
                        "Continuar",

                });

            } catch (error) {

                console.log(
                    "ERRO EMAIL:",
                    error.response?.data ||
                    error
                );


                Swal.fire({

                    icon:
                        "error",

                    title:
                        "Não foi possível concluir",

                    text:
                        error.response
                            ?.data
                            ?.mensagem ||

                        "Ocorreu um erro ao alterar o e-mail.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#ef4444",

                });

            }

        };


    /* =========================================================
       VALIDAR SENHAS
       ========================================================= */

    const validarSenhas =
        () => {

            if (

                values.novaSenha &&

                values.confirmarSenha &&

                values.novaSenha !==
                values.confirmarSenha

            ) {

                setErroSenha(
                    "As senhas não coincidem."
                );

                return;

            }


            setErroSenha("");

        };


    /* =========================================================
       CONFIRMAÇÃO DE ATUALIZAÇÃO
       ========================================================= */

    const confirmarAtualizacao =
        async () => {

            return Swal.fire({

                background:
                    "#08131d",

                color:
                    "#ffffff",

                width:
                    "470px",

                padding:
                    "0",

                title:
                    "Confirmar alterações?",

                html: `

                    <div class="confirmacao-cadastro">

                        <div class="confirmacao-header">

                            <div class="confirmacao-shield">

                                <svg
                                    viewBox="0 0 24 24"
                                    width="22"
                                    height="22"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.6"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >

                                    <path
                                        d="
                                            M12 3
                                            20 6
                                            v5
                                            c0 5.2-3.4 8.8-8 10
                                            -4.6-1.2-8-4.8-8-10
                                            V6l8-3z
                                        "
                                    />

                                    <path
                                        d="M9 12l2 2 4-4"
                                    />

                                </svg>

                            </div>

                            <div class="confirmacao-status">

                                <span class="confirmacao-status-dot"></span>

                                <span>
                                    CONFIRMAÇÃO DE SEGURANÇA
                                </span>

                            </div>

                        </div>


                        <div class="confirmacao-descricao">

                            Você está prestes a atualizar os dados
                            da sua conta.

                        </div>


                        <div class="confirmacao-resumo">

                            <div class="confirmacao-resumo-item">

                                <span class="confirmacao-resumo-icon">
                                    <svg
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.6"
                                    >
                                        <path d="M20 21a8 8 0 0 0-16 0"/>
                                        <circle
                                            cx="12"
                                            cy="7"
                                            r="4"
                                        />
                                    </svg>
                                </span>

                                <span>
                                    Dados pessoais
                                </span>

                            </div>


                            <div class="confirmacao-resumo-item">

                                <span class="confirmacao-resumo-icon">

                                    <svg
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.6"
                                    >

                                        <rect
                                            x="3"
                                            y="5"
                                            width="18"
                                            height="14"
                                            rx="2"
                                        />

                                        <path
                                            d="m3 7 9 6 9-6"
                                        />

                                    </svg>

                                </span>

                                <span>
                                    E-mail
                                </span>

                            </div>


                            <div class="confirmacao-resumo-item">

                                <span class="confirmacao-resumo-icon">

                                    <svg
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.6"
                                    >

                                        <path
                                            d="
                                                M22 16.9v3
                                                a2 2 0 0 1-2.2 2
                                                19.8 19.8 0 0 1-8.6-3.1
                                                19.5 19.5 0 0 1-6-6
                                                A19.8 19.8 0 0 1 2.1 4.2
                                                2 2 0 0 1 4.1 2h3
                                                a2 2 0 0 1 2 1.7
                                                c.1.9.3 1.8.6 2.6
                                                a2 2 0 0 1-.5 2.1L8 9.7
                                                a16 16 0 0 0 6.3 6.3
                                                l1.3-1.3
                                                a2 2 0 0 1 2.1-.5
                                                c.8.3 1.7.5 2.6.6
                                                A2 2 0 0 1 22 16.9z
                                            "
                                        />

                                    </svg>

                                </span>

                                <span>
                                    Telefone
                                </span>

                            </div>


                            <div class="confirmacao-resumo-item">

                                <span class="confirmacao-resumo-icon">

                                    <svg
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.6"
                                    >

                                        <rect
                                            x="4"
                                            y="10"
                                            width="16"
                                            height="11"
                                            rx="2"
                                        />

                                        <path
                                            d="M8 10V7a4 4 0 0 1 8 0v3"
                                        />

                                    </svg>

                                </span>

                                <span>
                                    Senha
                                </span>

                            </div>

                        </div>


                        <div class="confirmacao-info">

                            <span class="confirmacao-info-line"></span>

                            <span class="confirmacao-info-text">
                                Verifique os dados antes de salvar.
                            </span>

                        </div>

                    </div>

                `,

                showCancelButton:
                    true,

                confirmButtonText:
                    "Salvar alterações",

                cancelButtonText:
                    "Cancelar",

                reverseButtons:
                    true,

                allowOutsideClick:
                    false,

                scrollbarPadding:
                    false,

                buttonsStyling:
                    false,

                customClass: {

                    popup:
                        "confirmacao-cadastro-popup",

                    title:
                        "confirmacao-cadastro-title",

                    htmlContainer:
                        "confirmacao-cadastro-content",

                    actions:
                        "confirmacao-cadastro-actions",

                    confirmButton:
                        "confirmacao-cadastro-confirmar",

                    cancelButton:
                        "confirmacao-cadastro-cancelar",

                },

            });

        };


    /* =========================================================
       VERIFICAR ALTERAÇÕES
       ========================================================= */

    const verificarAlteracoes = () => {

        const nomeAtual =
            values.nome?.trim() || "";

        const nomeOriginal =
            dadosOriginais.nome?.trim() || "";


        const loginAtual =
            values.user?.trim() || "";

        const loginOriginal =
            dadosOriginais.user?.trim() || "";


        const telefoneAtual =
            (values.telefone || "")
                .replace(/\D/g, "");

        const telefoneOriginal =
            (dadosOriginais.telefone || "")
                .replace(/\D/g, "");


        const emailAtual =
            (values.email || "")
                .trim()
                .toLowerCase();

        const emailOriginal =
            (dadosOriginais.email || "")
                .trim()
                .toLowerCase();


        const nomeAlterado =
            nomeAtual !== nomeOriginal;


        const loginAlterado =
            loginAtual !== loginOriginal;


        const telefoneAlterado =
            telefoneAtual !== telefoneOriginal;


        const emailAlterado =
            emailAtual !== emailOriginal;


        const senhaAlterada =
            Boolean(
                values.senhaAtual ||
                values.novaSenha ||
                values.confirmarSenha
            );


        return {

            nomeAlterado,

            loginAlterado,

            telefoneAlterado,

            emailAlterado,

            senhaAlterada,

            algumaAlteracao:
                nomeAlterado ||
                loginAlterado ||
                telefoneAlterado ||
                emailAlterado ||
                senhaAlterada,

        };
    };


    /* =========================================================
       SALVAR CADASTRO
       ========================================================= */

    const handleSalvar =
        async () => {

            const problemas = [];

            /* =====================================================
               VERIFICAR ALTERAÇÕES
               ===================================================== */

            const alteracoes =
                verificarAlteracoes();


            if (!alteracoes.algumaAlteracao) {

                await Swal.fire({
                    background: "#08131d",
                    color: "#ffffff",

                    width: "390px",
                    padding: "0",

                    html: `
        <div class="swal-sem-alteracao">

            <div class="swal-sem-alteracao-header">

                <div class="swal-sem-alteracao-icon">
                    <span>—</span>
                </div>

                <div class="swal-sem-alteracao-status">
                    <span></span>
                    NENHUMA ALTERAÇÃO
                </div>

            </div>

            <div class="swal-sem-alteracao-title">
                Nenhuma alteração realizada
            </div>

            <div class="swal-sem-alteracao-text">
                Os dados da sua conta permanecem
                exatamente como estavam.
            </div>

        </div>
    `,

                    showConfirmButton: true,

                    confirmButtonText: "Entendi",

                    buttonsStyling: false,

                    scrollbarPadding: false,

                    customClass: {
                        popup: "swal-sem-alteracao-popup",
                        htmlContainer: "swal-sem-alteracao-content",
                        confirmButton: "swal-sem-alteracao-button",
                    },
                });

                return;
            }


            /* =====================================================
               NOME
               ===================================================== */

            if (
                alteracoes.nomeAlterado &&
                !values.nome?.trim()
            ) {

                problemas.push(
                    "Informe seu nome"
                );

            }


            /* =====================================================
               E-MAIL
               ===================================================== */

            if (
                alteracoes.emailAlterado &&
                !values.email_verificado
            ) {

                problemas.push(
                    "E-mail precisa estar verificado"
                );

            }


            /* =====================================================
               TELEFONE
               ===================================================== */

            if (
                alteracoes.telefoneAlterado &&
                values.telefone &&
                !values.telefone_verificado
            ) {

                problemas.push(
                    "Telefone precisa estar verificado"
                );

            }


            /* =====================================================
               SENHA
               Só valida se o usuário realmente começou
               a preencher algum campo de senha.
               ===================================================== */

            if (alteracoes.senhaAlterada) {




                if (!values.novaSenha) {

                    problemas.push(
                        "Informe a nova senha"
                    );

                }


                if (!values.confirmarSenha) {

                    problemas.push(
                        "Confirme a nova senha"
                    );

                }

            }


            /* =====================================================
               MOSTRAR PROBLEMAS
               ===================================================== */

            if (
                problemas.length > 0
            ) {

                await Swal.fire({

                    scrollbarPadding:
                        false,

                    title:
                        "Revise seus dados",

                    html: `

                        <div class="cadastro-alert">

                            <div class="cadastro-alert-header">

                                <div class="cadastro-alert-icon">
                                    !
                                </div>

                                <div class="cadastro-alert-status">

                                    <span class="status-dot"></span>

                                    <span>
                                        VALIDAÇÃO NECESSÁRIA
                                    </span>

                                </div>

                            </div>


                            <div class="cadastro-alert-description">

                                Os seguintes campos precisam ser
                                preenchidos antes de continuar.

                            </div>


                            <div class="cadastro-alert-list">

                                ${problemas
                            .map(
                                (
                                    item,
                                    index
                                ) => `

                                            <div class="cadastro-alert-row">

                                                <span class="cadastro-alert-index">
                                                    ${String(
                                    index + 1
                                ).padStart(
                                    2,
                                    "0"
                                )}
                                                </span>

                                                <span class="cadastro-alert-line"></span>

                                                <span class="cadastro-alert-text">
                                                    ${item}
                                                </span>

                                            </div>

                                        `
                            )
                            .join("")}

                            </div>

                        </div>

                    `,

                    background:
                        "#08131d",

                    color:
                        "#ffffff",

                    width:
                        "440px",

                    padding:
                        "0",

                    showConfirmButton:
                        true,

                    confirmButtonText:
                        "Entendi",

                    buttonsStyling:
                        false,

                    customClass: {

                        popup:
                            "swal-cadastro-tech",

                        title:
                            "swal-cadastro-tech-title",

                        htmlContainer:
                            "swal-cadastro-tech-content",

                        confirmButton:
                            "swal-cadastro-tech-button",

                    },

                });

                return;
            }


            /* =====================================================
               CONFIRMAR SENHAS
               ===================================================== */

            if (
                alteracoes.senhaAlterada &&
                values.novaSenha !==
                values.confirmarSenha
            ) {

                await Swal.fire({

                    icon:
                        "warning",

                    title:
                        "Senhas diferentes",

                    text:
                        "A nova senha e a confirmação precisam ser iguais.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#0f73b2",

                });

                return;
            }


            /* =====================================================
               TAMANHO DA SENHA
               ===================================================== */

            if (
                alteracoes.senhaAlterada &&
                values.novaSenha.length < 8
            ) {

                await Swal.fire({

                    icon:
                        "warning",

                    title:
                        "Senha muito curta",

                    text:
                        "A senha precisa ter pelo menos 8 caracteres.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#0f73b2",

                });

                return;
            }


            /* =====================================================
               CONFIRMAÇÃO FINAL
               ===================================================== */

            const confirmacao =
                await confirmarAtualizacao();


            if (
                !confirmacao.isConfirmed
            ) {

                return;
            }


            try {

                setLoading(
                    true
                );


                /* =================================================
                   LOADING
                   ================================================= */

            

                /* =================================================
                   1. ATUALIZAR NOME
                   ================================================= */

                if (alteracoes.nomeAlterado) {

                    await atualizarNome();

                }


                /* =================================================
                    3. ATUALIZAR LOGIN
                ================================================= */

                if (alteracoes.loginAlterado) {

                    const login =
                        values.user?.trim();


                    const verificacao =
                        await api.get(

                            "/verificar-login",

                            {
                                ...getHeaders(),

                                params: {
                                    user: login
                                }

                            }

                        );


                    if (!verificacao.data.disponivel) {

                        throw new Error(
                            "Este nome de login já está cadastrado."
                        );

                    }


                    await atualizarLogin();

                }

                /* =================================================
                   2. ATUALIZAR SENHA
                   ================================================= */

                if (alteracoes.senhaAlterada) {

                    await api.put(

                        "/usuario/atualizar-senha-logado",

                        {
                            novaSenha:
                                values.novaSenha,
                        },

                        getHeaders()

                    );

                }


                /* =================================================
                   OBSERVAÇÃO SOBRE TELEFONE

                   O fluxo existente deste JSX verifica o telefone
                   e confirma o código por SMS através dos endpoints
                   já utilizados acima. Não foi inventada uma nova
                   rota de atualização de telefone.
                   ================================================= */


                /* =================================================
                   ATUALIZAR REFERÊNCIA LOCAL
                   Depois que o salvamento terminou, os valores atuais
                   passam a ser considerados os novos valores originais.
                   ================================================= */

                setDadosOriginais({

                    nome:
                        values.nome?.trim() || "",

                    user:
                        values.user?.trim() || "",


                    email:
                        values.email?.trim() || "",

                    telefone:
                        values.telefone || "",

                    email_verificado:
                        values.email_verificado,

                    telefone_verificado:
                        values.telefone_verificado,

                });


                /* =================================================
                   LIMPAR SENHAS
                   ================================================= */

                setValues((prev) => ({

                    ...prev,

                    senhaAtual:
                        "",

                    novaSenha:
                        "",

                    confirmarSenha:
                        "",

                }));

                setErroSenha("");


                /* =================================================
                   SUCESSO
                   ================================================= */



                /* =================================================
                   VOLTAR PARA MAPS
                   ================================================= */

                navigate(
                    "/maps"
                );


            } catch (error) {

                console.log(
                    "ERRO AO ATUALIZAR CADASTRO:",
                    error.response?.data ||
                    error.message ||
                    error
                );


                Swal.fire({

                    icon:
                        "error",

                    title:
                        "Não foi possível atualizar",

                    text:
                        error.response
                            ?.data
                            ?.mensagem ||

                        error.message ||

                        "Ocorreu um erro ao atualizar seu cadastro.",

                    background:
                        "#0b1623",

                    color:
                        "#ffffff",

                    confirmButtonColor:
                        "#ef4444",

                    confirmButtonText:
                        "Entendi",

                });

            } finally {

                setLoading(
                    false
                );

            }

        };


    const handleAlterarNome = async () => {

        const confirmacao = await Swal.fire({

            background: "#08131d",

            width: "400px",

            padding: "0",

            html: `

        <div class="swal-alterar-campo">

            <div class="swal-alterar-campo-top">

                <div class="swal-alterar-campo-icon">
                    <FiUser />
                </div>

                <div class="swal-alterar-campo-status">
                    <span></span>
                    CONFIGURAÇÃO DA CONTA
                </div>

            </div>


            <div class="swal-alterar-campo-title">
                Alterar nome
            </div>


            <div class="swal-alterar-campo-text">

                Deseja habilitar a edição do nome
                cadastrado na sua conta?

            </div>


            <div class="swal-alterar-campo-info">

                <span class="swal-info-dot"></span>

                O campo será desbloqueado para edição.

            </div>

        </div>

    `,

            showCancelButton: true,

            confirmButtonText: "Continuar",

            cancelButtonText: "Cancelar",

            reverseButtons: true,

            buttonsStyling: false,

            allowOutsideClick: false,

            allowEscapeKey: true,

            scrollbarPadding: false,

            customClass: {

                popup:
                    "swal-alterar-campo-popup",

                htmlContainer:
                    "swal-alterar-campo-content",

                actions:
                    "swal-alterar-campo-actions",

                confirmButton:
                    "swal-alterar-campo-confirm",

                cancelButton:
                    "swal-alterar-campo-cancel",

            },

        });


        if (!confirmacao.isConfirmed) {

            return;

        }


        setEditandoNome(true);

    };


    /* =========================================================
       RENDER
       ========================================================= */

    return (

        <div className="atualizacao-container">


            {/* =====================================================
               HEADER
               ===================================================== */}

            <header className="atualizacao-header">

                <div className="atualizacao-header-content">

                    <div className="atualizacao-header-icon">


                        <img src={logo} alt="Logo" width={30} />

                    </div>


                    <div>

                        <span className="atualizacao-overline">
                            INOVA • SEGURANÇA
                        </span>

                        <h1>
                            Atualização de cadastro
                        </h1>

                        <p>
                            Mantenha seus dados atualizados
                            e sua conta protegida.
                        </p>

                    </div>

                </div>


                <div className="atualizacao-status">

                    <span></span>

                    Conta conectada

                </div>

            </header>


            {/* =====================================================
               CONTEÚDO
               ===================================================== */}

            <main className="atualizacao-main">


                {/* =================================================
                   CARD
                   ================================================= */}

                <div className="atualizacao-card">


                    {/* =================================================
                       VOLTAR
                       ================================================= */}

                    <Tooltip
                        title="Voltar para o mapa"
                    >

                        <button
                            type="button"
                            className="btn-voltar-cadastro"
                            onClick={() =>
                                navigate(
                                    "/maps"
                                )
                            }
                        >

                            <FiArrowLeft />

                        </button>

                    </Tooltip>


                    {/* =================================================
                       TOPO DO CARD
                       ================================================= */}

                    <div className="atualizacao-card-top">

                        <div>

                            <span className="card-label">
                                CONFIGURAÇÃO DA CONTA
                            </span>

                            <h2>
                                Seus dados
                            </h2>

                        </div>


                        <div className="card-indicator">

                            <span></span>

                            Dados sincronizados

                        </div>

                    </div>


                    {/* =================================================
                       DADOS PESSOAIS
                       ================================================= */}

                    <section className="cadastro-section">

                        <div className="section-heading">

                            <div className="section-heading-icon">

                                <FiUser />

                            </div>


                            <div>

                                <h3>
                                    Informações pessoais
                                </h3>

                                <p>
                                    Dados utilizados para identificar
                                    sua conta.
                                </p>

                            </div>

                        </div>


                        {/* =================================================
                           NOME
                           ================================================= */}

                        <div className="cadastro-field">
                            <label>
                                Nome
                            </label>

                            <div className="cadastro-field-header">



                                {!editandoNome && (

                                    <button
                                        type="button"
                                        className="text-action"
                                        onClick={handleAlterarNome}
                                    >
                                        Alterar nome
                                        <FiArrowRight />
                                    </button>

                                )}

                            </div>


                            <div

                                className={`
            input-container
            ${!editandoNome ? "input-bloqueado" : ""}
        `}
                            >
                                <input
                                    type="text"
                                    name="nome"
                                    value={values.nome}
                                    onChange={handleChange}
                                    placeholder="Seu nome"
                                    autoComplete="name"
                                    readOnly={!editandoNome}
                                />



                                <FiUser />




                                {!editandoNome && (

                                    <span className="campo-bloqueado">
                                        Bloqueado
                                    </span>

                                )}

                            </div>


                            {editandoNome && (

                                <div className="nome-editando-info">

                                    <span></span>

                                    Você pode editar seu nome agora.

                                </div>

                            )}

                        </div>



                        {/* =================================================
                            NOME DE LOGIN
                        ================================================= */}

                        <div className="cadastro-field">

                            <label>
                                Nome de login
                            </label>


                            <div className="cadastro-field-header">

                                {!editandoLogin && (

                                    <button
                                        type="button"
                                        className="text-action"
                                        onClick={handleAlterarLogin}
                                    >
                                        Alterar login
                                        <FiArrowRight />
                                    </button>

                                )}

                            </div>


                            <div
                                className={`
            input-container
            ${!editandoLogin ? "input-bloqueado" : ""}
        `}
                            >

                                <input
                                    type="text"
                                    name="user"
                                    value={values.user}
                                    onChange={handleChange}
                                    placeholder="Seu login"
                                    autoComplete="username"
                                    readOnly={!editandoLogin}
                                />

                                <FiUser />


                                {!editandoLogin && (

                                    <span className="campo-bloqueado">
                                        Bloqueado
                                    </span>

                                )}

                            </div>


                            {editandoLogin && (

                                <div className="nome-editando-info">

                                    <span></span>

                                    Você pode editar seu nome de login agora.

                                </div>

                            )}

                        </div>


                        {/* =================================================
                           E-MAIL
                           ================================================= */}

                        <div className="cadastro-field">

                            <label>
                                E-mail
                            </label>


                            <div className="input-status-row">

                                <div className="input-container">

                                    <FiMail />

                                    <input
                                        type="email"
                                        name="email"
                                        value={
                                            values.email
                                        }
                                        readOnly
                                    />

                                </div>


                                <div
                                    className={
                                        values.email_verificado

                                            ? "field-status status-ok"

                                            : "field-status status-error"
                                    }
                                >

                                    {values.email_verificado ? (

                                        <>
                                            <FiCheck />
                                            Verificado
                                        </>

                                    ) : (

                                        <>
                                            <FiAlertCircle />
                                            Não verificado
                                        </>

                                    )}

                                </div>

                            </div>


                            <button
                                type="button"
                                className="text-action"
                                onClick={
                                    handleAlterarEmail
                                }
                            >

                                Alterar e-mail

                                <FiArrowRight />

                            </button>

                        </div>


                        {/* =================================================
                           TELEFONE
                           ================================================= */}

                        <div className="cadastro-field">

                            <label>
                                Telefone
                            </label>


                            <div className="telefone-area">

                                <div className="input-container">

                                    <FiPhone />

                                    <InputMask
                                        mask="(99) 99999-9999"
                                        value={
                                            values.telefone
                                                ? values.telefone
                                                    .replace(
                                                        /\D/g,
                                                        ""
                                                    )
                                                    .replace(
                                                        /^55/,
                                                        ""
                                                    )
                                                : ""
                                        }
                                        onChange={
                                            handleChange
                                        }
                                        name="telefone"
                                        autoComplete="tel"
                                    >

                                        {(inputProps) => (

                                            <input
                                                {...inputProps}
                                                type="text"
                                                placeholder="(11) 99999-9999"
                                                className={
                                                    telefoneDisponivel === true

                                                        ? "input-valid"

                                                        : telefoneDisponivel === false

                                                            ? "input-invalid"

                                                            : ""
                                                }
                                            />

                                        )}

                                    </InputMask>

                                </div>


                                <div className="telefone-status-area">

                                    {verificandoTelefone ? (

                                        <div className="status-loading">

                                            <span className="mini-spinner"></span>

                                            Verificando...

                                        </div>

                                    ) : telefoneDisponivel === false ? (

                                        <div className="status-error">

                                            <FiAlertCircle />

                                            Já cadastrado

                                        </div>

                                    ) : telefoneDisponivel === true ? (

                                        <>

                                            <div className="status-ok">

                                                <FiCheck />

                                                Disponível

                                            </div>


                                            <button
                                                type="button"
                                                className="verify-button"
                                                onClick={
                                                    handleEnviarCodigo
                                                }
                                            >

                                                Verificar

                                            </button>

                                        </>

                                    ) : values.telefone_verificado ? (

                                        <div className="status-ok">

                                            <FiCheck />

                                            Verificado

                                        </div>

                                    ) : (

                                        <button
                                            type="button"
                                            className="verify-button"
                                            onClick={
                                                handleEnviarCodigo
                                            }
                                        >

                                            Verificar

                                        </button>

                                    )}

                                </div>

                            </div>


                            {telefoneDisponivel === false && (

                                <div className="validation-message error">

                                    Este número já está vinculado
                                    a outra conta.

                                </div>

                            )}


                            {telefoneDisponivel === true && (

                                <div className="validation-message success">

                                    Número disponível para cadastro.

                                </div>

                            )}

                        </div>

                    </section>


                    {/* =================================================
                       SEGURANÇA
                       ================================================= */}

                    <section className="cadastro-section security-section">

                        <div className="section-heading">

                            <div className="section-heading-icon">

                                <FiLock />

                            </div>


                            <div>

                                <h3>
                                    Segurança
                                </h3>

                                <p>
                                    Atualize sua senha para manter
                                    sua conta protegida.
                                </p>

                            </div>

                        </div>


                        {/* =================================================
                           NOVA SENHA
                           ================================================= */}

                        <div className="cadastro-field">

                            <label>
                                Nova senha
                            </label>


                            <div className="input-container password-input">

                                <FiLock />


                                <input
                                    type={
                                        mostrarSenha
                                            ? "text"
                                            : "password"
                                    }
                                    name="novaSenha"
                                    value={
                                        values.novaSenha
                                    }
                                    onChange={
                                        handleChange
                                    }
                                    onBlur={
                                        validarSenhas
                                    }
                                    placeholder="Digite sua nova senha"
                                    autoComplete="new-password"
                                />


                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() =>
                                        setMostrarSenha(
                                            !mostrarSenha
                                        )
                                    }
                                >

                                    {mostrarSenha

                                        ? <PiEyeClosedLight />

                                        : <PiEyeLight />

                                    }

                                </button>

                            </div>

                        </div>


                        {/* =================================================
                           CONFIRMAR SENHA
                           ================================================= */}

                        <div className="cadastro-field">

                            <label>
                                Confirmar nova senha
                            </label>


                            <div
                                className={`
                                    input-container
                                    password-input
                                    ${erroSenha
                                        ? "input-container-error"
                                        : ""
                                    }
                                `}
                            >

                                <FiLock />


                                <input
                                    type={
                                        mostrarSenha
                                            ? "text"
                                            : "password"
                                    }
                                    name="confirmarSenha"
                                    value={
                                        values.confirmarSenha
                                    }
                                    onChange={
                                        handleChange
                                    }
                                    onBlur={
                                        validarSenhas
                                    }
                                    placeholder="Repita sua nova senha"
                                    autoComplete="new-password"
                                />


                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() =>
                                        setMostrarSenha(
                                            !mostrarSenha
                                        )
                                    }
                                >

                                    {mostrarSenha

                                        ? <PiEyeClosedLight />

                                        : <PiEyeLight />

                                    }

                                </button>

                            </div>


                            {erroSenha && (

                                <div className="senha-erro">

                                    <FiAlertCircle />

                                    {erroSenha}

                                </div>

                            )}

                        </div>

                    </section>


                    {/* =================================================
                       FOOTER
                       ================================================= */}

                    <div className="cadastro-footer">


                        <div className="footer-info">

                            <FiShield />

                            <span>

                                Suas informações são protegidas
                                e utilizadas somente para
                                gerenciamento da sua conta.

                            </span>

                        </div>


                        <button
                            type="button"
                            className="btn-atualizar-cadastro"
                            onClick={
                                handleSalvar
                            }
                            disabled={
                                loading
                            }
                        >

                            {loading ? (

                                <>

                                    <span className="button-spinner"></span>

                                    Atualizando...

                                </>

                            ) : (

                                <>

                                    Atualizar cadastro

                                    <FiArrowRight />

                                </>

                            )}

                        </button>

                    </div>


                </div>

            </main>

        </div>

    );

}